module.exports = __webpack_public_path__ + "img/ywAward-4.3b6d6430.png";